import React, { useState } from 'react';
import { Button, Input, Modal, notification } from 'antd';
import UpdateInvoicePhone from '../../functions/invoice/updateInvoicePhone';
import { useUser } from '../../screens/user/context.js/userContext';

const AskUserPhone = ({ open, close, invoiceId, done }) => {
    const [phone, setPhone] = useState('')
    const { setPaying } = useUser()

    const changePhone = (e) => {
        const str = e.target.value
        if (str.length > 8) return;
        if (!/^\d+$/.test(str) && str.length !== 0) return;
        setPhone(str)
    }
    const donePhone = async () => {
        setPaying('Утасны дугаар шинэчилж байна...')
        const response = await UpdateInvoicePhone(invoiceId, phone)
        setPaying(null)
        if (response && response.success) done()
        if (response && response.error) return notification.error({ message: response.message })
    }
    return (
        <Modal open={open} size={250} footer={null} centered onCancel={close}>
            <div style={{ marginBottom: 10, width: '100%', textAlign: 'center', display: 'flex', alignItems: 'center', gap: 10, flexDirection: 'column' }}>
                <label htmlFor="phone" style={{ fontSize: 14, fontWeight: 'bold' }}>Та утасны дугаараа оруулна уу</label>
                <Input
                    id="phone"
                    value={phone}
                    placeholder=''
                    maxLength={8}
                    autoFocus
                    style={{ width: '70%', textAlign: 'center', letterSpacing: 1.7, fontSize: 18, fontWeight: 'bolder', height: 40, marginTop: 15 }}
                    onChange={changePhone}
                />
                <small style={{ display: 'block', marginTop: 5, color: '#777' }}>
                    Утасны дугаар 8 оронтой байх ёстой
                </small>
                <Button
                    onClick={donePhone}
                    disabled={phone.length !== 8}
                    style={{ marginTop: 15 }}
                    type='primary'
                    className='spayDefaultButton'
                >
                    Үргэлжлүүлэх
                </Button>
            </div>

        </Modal>

    );
};

export default AskUserPhone;